export default __webpack_public_path__ + "static/media/logo_lattice.d83b25c1.svg";